// extracted by mini-css-extract-plugin
export default {"container":"pmxYShNSayRGaD24Oxi2","icon":"R41Kc7_XCgXJ_V7Fwt0B","text":"EdezMMduxamklbepcfcK","closeButton":"x7fSIeB5Avb68NwiL7yx","closeIcon":"d_Da7T3HBK0VEYVUygkI"};